import React from 'react';
import './ContactSection.scss';
import SectionTitle from '../../../../components/SectionTitle/SectionTitle';
import { FaPhone } from "react-icons/fa6";
const elzbietaPhoto = require('../../../../assets/images/experts/elzbieta.jpg');

const ContactSection = () => {
    const list = [
        {text: 'Pon-pt 8:00-20:00 | Sob 8:00-18:00 | Ndz 8:00-12:00'},
        {text: 'Tel: 782 949 818', icon: <FaPhone />},
    ];
    return (
        <section className='contact section-m section-p'>
            <div className="container">
                <div className="row align-items-center">
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div className="section-text contact-section-text">
                            <SectionTitle 
                                subTitle={''}
                                title={'Masz pytania lub chciałbyś umówić wizytę?'}
                                description={'Nasza rejestratorka Elżbieta z chęcią pomoże znaleźć odpowiedni termin wizyty lub sprawdzi dostępność do Twojego specjalisty. Skontaktuj się z nami - zadbamy o Twoje zdrowie. Zapraszamy do kontaktu:'}
                            />
                            <ul>
                                {list.map((item, index) => (
                                    <li key={index}>
                                        {item.icon}
                                        {item.text}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div className="contact-section-img">
                            <img src={elzbietaPhoto} alt="zdjęcie rejestratorki" />
                        </div>
                    </div>
                </div>
                </div>
        </section>
    );
};

export default ContactSection;